module.exports = __webpack_public_path__ + "static/media/child-image.20c6ea9f.png";